import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { useRolesRetrieval } from "@planzone/view-models";
import { SelectedIcon } from "@common/selectedIcon";
import { SelectList } from "@common/selectList";
import { Props } from "./types";
import { ArrowIcon } from "./arrowIcon";
import styles from "./styles.scss";

function RoleSelection(props: Props) {
  const { t } = useTranslation();
  const { roles } = useRolesRetrieval();

  React.useEffect(() => {
    roles.forEach((role) => role.name === "pz_user" && props.select(role));
  }, []);

  return (
    <div>
      <SelectList listClassName={styles.list}>
        {({ isOpen, select }) => ({
          input: (
            <div
              className={classNames(styles.roleSelection, {
                [styles.opened]: isOpen,
              })}
            >
              <div className={styles.input}>
                {props.selectedRole ? (
                  <p className={styles.selection}>
                    {t(
                      `roles.${props.selectedRole.name}`,
                      props.selectedRole.name,
                    )}
                  </p>
                ) : (
                  <p
                    className={classNames(styles.selection, styles.placeholder)}
                  >
                    {props.placeholder}
                  </p>
                )}
                <div className={styles.iconBox}>
                  <ArrowIcon className={styles.icon} />
                </div>
              </div>
            </div>
          ),
          list: (
            <div>
              {roles
                .filter(({ name }) => name.slice(0, "pz".length) === "pz")
                .map((role) => (
                  <div
                    key={role.uuid}
                    className={styles.role}
                    onClick={() => select(props.select(role))}
                  >
                    {props.selectedRole &&
                    props.selectedRole.name === role.name ? (
                      <div className={styles.selectedRole}>
                        <div className={styles.selectedRoleTitle}>
                          {t(`roles.${role.name}`, role.name)}{" "}
                          <SelectedIcon className={styles.selectedRoleIcon} />
                        </div>
                      </div>
                    ) : (
                      <div>{t(`roles.${role.name}`, role.name)}</div>
                    )}
                    <div className={styles.roleDescription}>
                      {t(`roles.description.${role.name}`, role.name)}
                    </div>
                  </div>
                ))}
            </div>
          ),
        })}
      </SelectList>
    </div>
  );
}

export { RoleSelection };
